import { ButtonLink, Icon, Text } from '@intellecteu/common-ui';
import { Labels, monitoringNotInstalledMessage } from 'app/constants';
import { Modal } from '../modal';

import s from './styles.module.scss';

type NotInstalledModalProps = {
  appName: string;
  docsUrl: string;
  supportUrl: string;
  onClose: () => void;
};

export const NotInstalledModal = ({ appName, docsUrl, supportUrl, onClose }: NotInstalledModalProps) => {
  const { beforeLink, afterLink } = monitoringNotInstalledMessage(appName);

  return (
    <Modal onClose={onClose} title={Labels.MONITORING_NOT_INSTALLED_TITLE}>
      <div className={s.notInstalled}>
        <Text>
          {beforeLink}
          <a href={docsUrl} target="_blank" rel="noreferrer" className={s.notInstalledLink}>
            {Labels.MONITORING_INSTALLATION_INSTRUCTIONS}
            <Icon icon={Icon.icons.openLink} size="s" />
          </a>
          {afterLink}
        </Text>
        <div className={s.notInstalledFooter}>
          <ButtonLink to={supportUrl} target="_blank" rel="noopener noreferrer" replace>
            <Icon icon={Icon.icons.openLink} size="s" />
            {Labels.MONITORING_CONTACT_SUPPORT}
          </ButtonLink>
        </div>
      </div>
    </Modal>
  );
};
